import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { Subscription } from 'rxjs';
import { add, endOfDay, format, startOfDay, getYear, parse } from 'date-fns';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { LoaderListPlaceholderComponent } from '../../shared-with-client/loader-list-placeholder/loader-list-placeholder.component';
import { DateFixPipe } from '../../shared-with-client/pipes/date-fix.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-client-day',
    templateUrl: './client-day.component.html',
    styleUrls: ['./client-day.component.scss'],
    imports: [NgIf, NgFor, LoaderListPlaceholderComponent, DatePipe, DateFixPipe, TranslatePipe],
    standalone: true
})
export class ClientDayComponent implements OnInit, OnDestroy {

  @Input() store;
  @Input() services;
  @Input() providers;
  @Output() saved = new EventEmitter;

  public getStoreAvailabilitySubscription: Subscription;

  public days;
  public loading = true;
  public lastLoadedDate;

  public retryCount = 0;
  public stopLoadingDays = false;
  private currentYear: number;

  constructor(private clientService: ClientService) { }

  ngOnInit() {
    const dateInit = startOfDay(new Date());
    const providers = this.providers?.length && this.providers.map(i => i.id);
    const services = this.services.map((i) => i.id);

    this.currentYear = (new Date()).getFullYear();

    const requestCache = this.clientService.daySearchResultCache.getValue();
    if (requestCache.storeId === this.store.id &&
      requestCache.providers === providers.join(',') &&
      requestCache.services ===  services.join(',')) {
        this.days = requestCache.days;
        this.lastLoadedDate = requestCache.lastLoadedDate;
        this.loading = false;
      } else {
        this.getAvailabilty(dateInit, providers, services);
    }
  }

  ngOnDestroy() {
    if (this.getStoreAvailabilitySubscription) {
      this.getStoreAvailabilitySubscription.unsubscribe();
    }
  }

  getAvailabilty(dateInit: Date, providers, services) {
    this.loading = true;
    const dateEnd = add(dateInit, {days: 12});


    const payload = {
      storeId: this.store.id,
      providers: providers,
      services: services,
      dateInit: format(dateInit, `yyyy-MM-dd'T'HH:mm:ss'Z'`),
      dateEnd: format(dateEnd, `yyyy-MM-dd'T'HH:mm:ss'Z'`),
    };

    this.getStoreAvailabilitySubscription = this.clientService.getStoreAvailability(payload).subscribe(res => {
      if (this.days) {
        res.forEach(v => this.days.push(v));
      } else {
        this.days = res;
      }
      this.lastLoadedDate = dateEnd;

      if (this.store.maxDaysInAdvance && this.lastLoadedDate > add(endOfDay(new Date()), { days: this.store.maxDaysInAdvance})) {
        this.stopLoadingDays = true;
      }

      if (res.length === 0 && this.retryCount < 60 && !this.stopLoadingDays) {
        this.loadMoreDays(this.lastLoadedDate);
        this.retryCount = this.retryCount + 1;
      } else {
        this.retryCount = 0;
        this.loading = false;

        this.clientService.daySearchResultCache.next({
          providers: providers.join(','),
          services: services.join(','),
          storeId: this.store.id,
          days: this.days,
          lastLoadedDate: this.lastLoadedDate
        })
      }
    });
  }

  loadMoreDays(lastDay) {
    const providers = this.providers?.length && this.providers.map(i => i.id);
    const services = this.services.map((i) => i.id);
    this.getAvailabilty(lastDay, providers, services);
  }

  selectDay(day) {
    this.saved.emit(day);
  }

  dateFormat(date) {
    if (date && getYear(parse(date, 'yyyy-MM-dd', new Date())) !== this.currentYear) {
      return 'd MMMM, YYYY';
    } else {
      return 'd MMMM';
    }
  }
}
